const ContactUsScreen = () => {
  return (
    <div style={{ textAlign: "center", justifyContent: "center" }}>
      {" "}
      <h5>
        Incase of Any issues or query, Please contact us in the below email or
        mobile numbers
      </h5>
      <h4>
        Email : <label>reachus@gymfort.in</label> <br></br>
      </h4>
      <br></br>
      <h4>
        Mobile : +91 6382131216<br></br>
      </h4>
    </div>
  );
};

export default ContactUsScreen;
